import type * as CSS from 'csstype';
import styled from 'styled-components';

import { mixins } from '../../../style/mixins';
import type { Size as ThemeSize } from '../../../style/types/theme';
import { Size } from '../types';

interface WrapperProps {
  $width: CSS.Property.Width;
  $height?: CSS.Property.Height;
  $minWidth?: CSS.Property.MinWidth;
  $maxWidth: CSS.Property.MaxWidth;
  $minHeight?: CSS.Property.MinHeight;
  $maxHeight?: CSS.Property.MaxHeight;
  $transparentBackground?: boolean;
  $fullHeight?: boolean;
}

export const getWidthFromSize = (
  width: CSS.Property.Width,
  themeSize: ThemeSize,
): CSS.Property.Width => {
  switch (width) {
    case Size.SMALL:
      return themeSize.units(52);
    case Size.MEDIUM:
      return themeSize.units(80);
    case Size.LARGE:
      return themeSize.units(110);
    default:
      return width;
  }
};

export const ModalWrapper = styled.div.attrs<WrapperProps>(
  ({
    theme: { size, shadow, color },
    $width,
    $height = 'auto',
    $maxWidth,
    $minHeight,
    $maxHeight,
    $transparentBackground,
  }) => ({
    // we use styles for these since they might be rapidly changing
    // when the screen is resized
    style: {
      boxShadow: $transparentBackground ? undefined : shadow.modal,
      backgroundColor: $transparentBackground
        ? undefined
        : color.background.primary.default(),
      maxWidth: $maxWidth,
      minHeight: $minHeight,
      maxHeight: $maxHeight,
      height: $height,
      width: getWidthFromSize($width, size),
    },
  }),
)<WrapperProps>(({ theme: { borderRadius }, $fullHeight }) => ({
  borderRadius: $fullHeight ? 0 : borderRadius.large,

  ...mixins.responsive.sm.downward({
    borderRadius: `${borderRadius.large} ${borderRadius.large} 0 0`,
    // we need to use impotant to override inline styles
    width: '100% !important',
    maxWidth: '100% !important',
  }),
}));
